export const blackFriday = {
  // BlackFridayHero
  timeToUpgrade: "Time to Upgrade",
  getLowestPriceOfTheYear:
    "Don’t wait! the lowest annual <1/> price of the year ends soon.",
  beforeItsTooLate: "The lowest annual price of the year ends soon. ",
  getTheDeal: "Get the deal",

  // BlackFridayScreen
  blackFridaySpecial: "Black Friday Special",
  blackFridayGetAnnualFor49: "Black Friday: Get annual for $49",
  subscribe: "Subscribe",
  blackFridayDeal: "Black Friday Deal",
  lowestPriceOfTheYearExpiresIn: "Lowest price of the year expires in...",
  getOurBestDeal: "Get our best deal of the year",
  becomeAGoldMemberToAccess:
    "Become a Gold Member to access over 100,000 comics & manga",
  blackFridayCovers: "Black Friday Covers",
  dontMissTheBestDealOfTheYear: "Don't miss the Best Deal of the Year",
  chanceToPowerUp:
    "This Black Friday, it's your chance to power up with GlobalComix Gold. <1/> Get our <2> annual plan </2> at our  <2> once-a-year price of $49 </2> and unlock 100,000+ comics from DC, Dark Horse, Marvel, Image, and countless indie legends.",
  expiresIn: "EXPIRES IN:",

  // Pricing Section
  getAnAnnualPlan: "Get an annual plan for a once-a-year price.",
  annualPlan: "annual plan",
  onceAYear: "once-a-year",
  price: "$49.00",
  priceDollars: "$",
  priceCents: ".00",

  // Payment
  upgradeAndSave: "Upgrade and save",

  // Testing (remove these in production)
  aTagDeeplinkTest: "A tag deeplink test",
  testForDeeplink: "Test for deeplink",
};
